// src/config.js
export const materials = [
    {
        "name": "毒气精华",
        "identifier": "poison_essence",
        "description": "用于制作魔法物品或者给武器附魔，增加战斗中的策略性。",
        "get_function": "击败奇幻双重龙或与商人交易."
    },
    {
        "name": "雷电精华",
        "identifier": "lightning_essence",
        "description": "用于制作魔法物品或者给武器附魔，增加战斗中的策略性。",
        "get_function": "击败奇幻双重龙或与商人交易."
    },
    {
        "name": "双难鳞片",
        "identifier": "double_difficulty_scales",
        "description": "制作防御装备，提供对两种毒气伤害和雷电的高度抵抗力。",
        "get_function": "击败奇幻双重龙或与商人交易."
    },
    {
        "name": "纯净之心鳞片",
        "identifier": "pure_heart_scales",
        "description": "用于制作能够净化一切负面效果以及给予大量正面效果的材料。",
        "get_function": "击败光霓."
    },
    {
        "name": "夜焰等离子",
        "identifier": "night_flame_plasma",
        "description": "制作高能量武器或装备，能够在战斗中造成大量等离子伤害。",
        "get_function": "击败影煞或与商人交易."
    },
    {
        "name": "影翼膜",
        "identifier": "shadow_wing_membrane",
        "description": "用于制作提高隐秘性或夜间活动能力的装备，如增强夜视的头盔。",
        "get_function": "击败影煞或与商人交易."
    },
    {
        "name": "恐怖之焰",
        "identifier": "flame_of_terror",
        "description": "制造能够释放恐怖效果，使敌人退缩或混乱的武器。",
        "get_function": "击败可爱龙."
    },
    {
        "name": "风切羽毛",
        "identifier": "wind_cut_feathers",
        "description": "用于制作能够增加移动速度或飞行能力的装备，如加速靴或飞行斗篷。",
        "get_function": "击败御风龙."
    },
    {
        "name": "噩梦火腺",
        "identifier": "nightmare_fire_gland",
        "description": "制作能够持续燃烧敌人的烈焰武器。",
        "get_function": "击败噩梦."
    },
    {
        "name": "火焰脊椎",
        "identifier": "flame_spine",
        "description": "增强物理攻击力，为近战武器添加火焰伤害。",
        "get_function": "击败噩梦."
    },
    {
        "name": "梦境鳞片",
        "identifier": "dream_scales",
        "description": "制作能够影响敌人心智，造成幻觉的魔法物品。",
        "get_function": "击败噩梦."
    },
    {
        "name": "纳德体液",
        "identifier": "nader_body_fluids",
        "description": "可以用于涂抹在武器护甲上,以使敌对目标中毒。",
        "get_function": "击败殒命尖刺."
    },
    {
        "name": "纳德刺",
        "identifier": "nader_thorn",
        "description": "可以用于制作武器,或者增加防御装备的反击伤害，或制造能够在接触时伤害敌人的陷阱。",
        "get_function": "击败殒命尖刺."
    },
    {
        "name": "葛伦科铁块",
        "identifier": "glencoe_iron_block",
        "description": "打造极为坚固的防具和武器，能够承受巨大的伤害。",
        "get_function": "击败伦克龙或与商人交易."
    },
    {
        "name": "重质鳞片",
        "identifier": "heavy_scales",
        "description": "用于制作重型护甲，提供高等级的物理和魔法防御。",
        "get_function": "击败伦克龙或与商人交易."
    },
    {
        "name": "钳夹毒液",
        "identifier": "clamp_venom",
        "description": "制作腐蚀药剂或给武器附魔。",
        "get_function": "击败鬼亡钳."
    },
    {
        "name": "暗之晶体",
        "identifier": "dark_crystal_ore",
        "description": "晶体中存在的黑暗仿佛能够吞噬一切.",
        "get_function": "挖掘暗之晶体矿石."
    },
    {
        "name": "光之晶体",
        "identifier": "light_crystal_ore",
        "description": "泛着淡淡的微光,能够照亮前路.",
        "get_function": "挖掘光之晶体矿石."
    },
    {
        "name": "魔法晶体",
        "identifier": "magic_crystal_ore",
        "description": "晶体中存在着一股魔法的力量.",
        "get_function": "挖掘魔法晶体矿石."
    },
    {
        "name": "彩虹晶体",
        "identifier": "rainbow_crystals_ore",
        "description": "闪耀着彩虹的光芒,天然被当作货币的存在.",
        "get_function": "挖掘晶体矿石有概率取得."
    }
];